<template>
    <DsModal
        id="campaign-builder-timer-modal"
        class="timer-modal"
        is-open
        :show-close="showClose"
        :size="size"
        :title="title"
        @close="close"
    >
        <template #header>
            <DsFilledButton data-qa="timer-modal-save-button" :disabled="!showSave" @click="save">
                {{ $options.MESSAGE_CONSTANTS.actionButtonLabel }}
            </DsFilledButton>
        </template>

        <template #default>
            <div class="timer-summary">
                <div class="timer-summary-label">
                    {{ $options.MESSAGE_CONSTANTS.summaryLabel }}
                </div>

                <div class="timer-summary-text">
                    <slot name="timerSummary" />
                </div>
            </div>

            <div class="timer-configuration">
                <slot name="timerParameters" />
            </div>

            <div v-if="timerTipText" class="timer-tip">
                <div class="timer-tip-icon">
                    <DsIcon name="info-circle" />
                </div>

                <div class="timer-tip-text">
                    {{ timerTipText }}
                    <div>
                        <DsFilledButton
                            v-if="timerTipLink"
                            class="timer-tip-button"
                            as="a"
                            :href="timerTipLink"
                            target="_blank"
                            trailing-icon="external-link"
                        >
                            <div>
                                {{ $options.MESSAGE_CONSTANTS.timerTipButtonLabel }}
                            </div>
                        </DsFilledButton>
                    </div>
                </div>
            </div>
        </template>
    </DsModal>
</template>

<script>

export const MESSAGE_CONSTANTS = {
    actionButtonLabel: 'Save',
    timerTipButtonLabel: 'Learn more',
    summaryLabel: 'Timer summary',
};

export default {
    MESSAGE_CONSTANTS,

    props: {
        timerTipLink: {
            type: String,
            default: '',
        },
        timerTipText: {
            type: String,
            default: '',
        },
        size: {
            type: String,
            default: 'med',
        },
        showClose: {
            type: Boolean,
            default: true,
        },
        showSave: {
            type: Boolean,
            default: true,
        },
        title: {
            type: String,
            required: true,
        },
    },

    emits: ['close-modal', 'update-config'],

    methods: {
        close() {
            this.$emit('close-modal');
        },

        save() {
            this.$emit('update-config');
        },
    },
};
</script>

<style lang="scss" scoped>
.timer-modal {
    --modal-padding: 0;
}

.timer-summary-label {
    font-size: 12px;
    color:      $color-ink-800;
    margin-bottom: $spacing-075;
}

.timer-configuration {
    margin: 24px 0 0 0;
}

.timer-tip {
    display:            flex;
    padding:            12px;
    border-radius:      8px;
    flex-wrap:          wrap;
    justify-items:      left;
    background-color:   $color-blue-050;
}

.timer-tip-icon {
    flex:   6%;
    color:  $color-blue-300;
}

.timer-tip-text {
    margin-top: 2px;
    flex:   94%;
    color:  $color-ink-900;
}

.timer-tip-button {
    height:             32px;
    margin-top:         8px;
    padding:            8px 12px 8px 8px;
    border-radius:      8px;
    color:              $color-ink-900;
    background-color:   $color-ink-100;
}
</style>
